/**
 * PATH: apps/quote/src/components/builder/application-selector-modal/FilterPanel.tsx
 * PURPOSE: Collapsible filter row for ApplicationSelectorModal
 */

import { Building2, Layers, Sun, Package } from 'lucide-react'
import type { Supplier } from '@/lib/quoteApi'
import { type FilterState, AREA_TYPES, SUBSTRATE_TYPES, EXPOSURE_TYPES } from './types'

interface FilterPanelProps {
  filters: FilterState
  suppliers: Supplier[]
  activeFilterCount: number
  onFilterChange: (key: keyof FilterState, value: string) => void
  onClearFilters: () => void
}

export default function FilterPanel({
  filters,
  suppliers,
  activeFilterCount,
  onFilterChange,
  onClearFilters,
}: FilterPanelProps) {
  return (
    <div className="px-4 pb-4 flex flex-wrap items-center gap-3">
      <div className="flex items-center gap-2">
        <Building2 className="w-4 h-4 text-slate-400" />
        <select value={filters.areaType} onChange={(e) => onFilterChange('areaType', e.target.value)} className="text-sm border border-slate-200 dark:border-slate-700 rounded-lg px-2 py-1.5 bg-white dark:bg-slate-800">
          {AREA_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
      </div>

      <div className="flex items-center gap-2">
        <Layers className="w-4 h-4 text-slate-400" />
        <select value={filters.substrateType} onChange={(e) => onFilterChange('substrateType', e.target.value)} className="text-sm border border-slate-200 dark:border-slate-700 rounded-lg px-2 py-1.5 bg-white dark:bg-slate-800">
          {SUBSTRATE_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
      </div>

      <div className="flex items-center gap-2">
        <Sun className="w-4 h-4 text-slate-400" />
        <select value={filters.exposureType} onChange={(e) => onFilterChange('exposureType', e.target.value)} className="text-sm border border-slate-200 dark:border-slate-700 rounded-lg px-2 py-1.5 bg-white dark:bg-slate-800">
          {EXPOSURE_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
      </div>

      <div className="flex items-center gap-2">
        <Package className="w-4 h-4 text-slate-400" />
        <select value={filters.supplierId} onChange={(e) => onFilterChange('supplierId', e.target.value)} className="text-sm border border-slate-200 dark:border-slate-700 rounded-lg px-2 py-1.5 bg-white dark:bg-slate-800">
          <option value="all">All Suppliers</option>
          {suppliers.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
      </div>

      {activeFilterCount > 0 && (
        <button onClick={onClearFilters} className="text-sm text-indigo-600 dark:text-indigo-400 hover:underline">
          Clear all
        </button>
      )}
    </div>
  )
}
